import AdminProfilePage from './adminProfilePage';

export default AdminProfilePage;
